import { Container } from "@mui/material";
import React, { Suspense } from 'react'
import {
  Redirect,
  Route,
  Switch
} from 'react-router-dom'

// routes config
import routes from '../routes'
  
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const TheContent = () => {
  return (
    <>
    <main className="c-main" style={{minHeight: "90vh", height: '90vh',maxHeight: '90vh', maxWidth: "100%",overflowY: 'auto'}}>
      <Container justify="center" style={{ maxWidth: "100%", paddingLeft: "15px", paddingRight: "15px"}}>
        <Suspense fallback={loading}>
          <Switch>
            {routes.map((route, idx) => {
              return route.component && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  render={props => (
                    
                      <route.component {...props} />
                    
                  )} />
              )
            })}
            <Redirect from="/" to="/dashboard" />
          </Switch>
        </Suspense>
      </Container>
    </main>
   </>
  )
}

export default React.memo(TheContent)
